import { FC } from 'react';

import { Formik } from 'formik';
import { type FormikHelpers } from 'formik';
import { DATA_RECORD_ACTION, DATA_RECORD_SOURCE } from 'utils/types';
import { useExternalModal } from 'ui/partials/Modal/useModal';
import { ExportDataModal } from 'ui/components/common';

import {
  EXPORT_DATA_CONFIGURATOR_FORM,
  EXPORT_DATA_CONFIGURATOR_SCHEMA,
} from '../forms/schema';
import ExportDataForm from '../forms/ExportDataForm';
import { useCreateCustomExport } from '../hooks';

type PROPS = {
  source: DATA_RECORD_SOURCE;
  onClose?: () => void;
};
const ExportDataConfiguratorModal: FC<PROPS> = ({ source, onClose }) => {
  const { mutate: exportData } = useCreateCustomExport();
  const {
    showModal: showExportConfirmationModal,
    hideModal: hideExportConfirmationModal,
  } = useExternalModal();

  const initialValues: EXPORT_DATA_CONFIGURATOR_FORM = {
    selected: [
      {
        label: 'ID',
        value: '_id',
        type: 'key',
      },
    ],
  };

  const onSubmit = (
    values: EXPORT_DATA_CONFIGURATOR_FORM,
    { setSubmitting }: FormikHelpers<EXPORT_DATA_CONFIGURATOR_FORM>,
  ) => {
    showExportConfirmationModal({
      title: 'Export',
      content: (
        <ExportDataModal
          onConfirm={() => {
            exportData({
              source,
              action: DATA_RECORD_ACTION.EXPORT,
              meta: {
                fields:
                  values.selected?.map((val) => {
                    if (val.type === 'key') {
                      return {
                        key: val.value,
                      };
                    }
                    return {
                      dataId: val.value,
                    };
                  }) ?? [],
              },
            });
            hideExportConfirmationModal();
            onClose?.();
          }}
          onCancel={hideExportConfirmationModal}
        />
      ),
    });
    setSubmitting(false);
  };
  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={EXPORT_DATA_CONFIGURATOR_SCHEMA}
    >
      {() => <ExportDataForm source={source} onClose={onClose} />}
    </Formik>
  );
};

export default ExportDataConfiguratorModal;
